export default __webpack_public_path__ + "static/media/beach_3.3b88a26a.jpg";